/* RESPONSIBLE TEAM: team-app-security */
import Service from '@ember/service';
import { task } from 'ember-concurrency-decorators';
import ajax from 'embercom/lib/ajax';

interface ScimGroup {
  id: number;
  name: string;
  priority?: number;
}

interface ScimGroupResponse {
  groups: ScimGroup[];
}

export default class ScimGroupService extends Service {
  @task({ restartable: true })
  *fetchUserGroups(appId: string, adminId: string): Generator<any, ScimGroupResponse | null, any> {
    if (!appId || !adminId) {
      return null;
    }

    try {
      let result: ScimGroup[] = yield ajax({
        url: '/ember/scim_group/user_groups',
        type: 'GET',
        data: {
          app_id: appId,
          admin_id: adminId,
        },
      });

      return { groups: result };
    } catch (error) {
      console.error('Failed to fetch SCIM user groups:', error);
      return null;
    }
  }

  getTopPriorityGroup(groups: ScimGroup[]): ScimGroup | null {
    if (!groups || groups.length === 0) {
      return null;
    }

    return groups.reduce((acc: ScimGroup | null, current: ScimGroup) => {
      if (!acc) {
        return current;
      }

      if (acc.priority !== undefined && current.priority !== undefined) {
        // Lower priority number = higher priority (more important)
        return current.priority < acc.priority ? current : acc;
      }

      if (acc.priority === undefined && current.priority === undefined) {
        return acc;
      }

      return acc.priority === undefined ? acc : current;
    });
  }
}
